<div *ngIf="type=='Represantative very Briefly'">
  <div id="print-section" class="print-wrapper">
    <table class="table table-bordered">
      <thead>
        <tr>
            <th colspan="9" style="border: 0px solid #ffffff;border-bottom: 1px solid #000;border-left: 1px solid #000; font-size: medium; text-align: center; padding: 5px;">
             <span>ADVT Registration Report - Very Briefly Represantative</span></th>
        </tr>
        <tr>
          <th colspan="3" style="border: 0px solid #ffffff;border-bottom: 1px solid #000;border-left: 1px solid #000; font-size: medium; text-align: center; padding: 5px;">
             <span>हिंदुस्तान
              प्रकाशन संस्था-विवेक साप्ताहिक</span></th>
            
          <th colspan="3" style="border: 0px solid #fdfdfd;border-bottom: 1px solid #000; font-size: medium; text-align: center; padding: 5px;">
             <span><strong>अंकाचे कॅटेगरी :</strong> &nbsp; {{issue_cat}} </span></th>    
          <th colspan="3" style="border: 0px solid #ffffff;border-bottom: 1px solid #000;border-right: 1px solid #000; font-size: medium; text-align: center; padding: 5px;">
            <span><strong>दिनांक :</strong> {{today1}}</span>
          <span>   <strong></strong></span>
          </th>
        </tr>
        <tr>
          <th colspan="3" style="border: 0px solid #ffffff;border-bottom: 1px solid #000;border-left: 1px solid #000; font-size: medium; text-align: center; padding: 5px;">
            <strong>अंकाचे नाव :</strong> &nbsp; {{newissuedatepp}}
            
           
          </th>

           <th colspan="3" style="border: 0px solid #ffffff;border-bottom: 1px solid #000;border-left: 1px solid #000; font-size: medium; text-align: center; padding: 5px;">
            <strong>अंकाची  दिनांक :</strong> &nbsp; {{issuedatepp | date : "dd-MM-yyy"}}
            
           
          </th>
          <th colspan="3" style="border: 0px solid #000;border-bottom: 1px solid #000;border-right: 1px solid #000; font-size: medium; text-align: center; padding: 5px;">
            <strong>From {{ start_date | date: 'dd-MM-yyyy' }} To {{ end_date | date: 'dd-MM-yyyy' }}</strong>
            
           
          </th>
        </tr>
        <tr>
          <th style="border: 1px solid #000; width: 0%;font-size: 14px; ">Sr</th>
          <th style="border: 1px solid #000; width: 0%; text-align: center; font-size: 14px; ">Advt Name</th>
          <th style="border: 1px solid #000; text-align: end; width: 0%;font-size: 14px;">Advt Amt</th>
          <th style="border: 1px solid #000; text-align: center; width: 5%; font-size: 14px; ">Net Amt</th>
          <th style="border: 1px solid #000; text-align: center; width: 0%;font-size: 14px; ">Before <br>
                                                                                          GST Amt</th>
          <th style="border: 1px solid #000; text-align: center; width: 0%;font-size: 14px; ">GST Amt</th>
          <th style="border: 1px solid #000; text-align: center; width: 0%;font-size: 14px; ">Total  Amt</th>
          <th style="border: 1px solid #000; text-align: center; width: 0%;font-size: 14px; ">Receive Amt</th>
          <th style="border: 1px solid #000; text-align: center; width: 0%;font-size: 14px; ">Pending Amt</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let item1 of inDetailsRegReportrep; let i = index">
          <tr style="width: 100%;">
            <td style="border: 1px solid #000; font-weight: bold; text-align: center;width: 6%;">{{i + 1}}</td>
            <td style="border: 1px solid #000; text-align: start; font-weight: bold;width: 20%;">{{item1.rep_name}}</td>
            <td style="border: 1px solid #000; text-align: end; font-weight: bold;width: 11%;">{{item1.total_advt_amount}}</td>
            <td style="border: 1px solid #000; text-align: end; font-weight: bold;width: 11%;">{{item1.total_discounted_amt}}</td>
            <td style="border: 1px solid #000; text-align: end; font-weight: bold;width: 10%;">{{item1.total_before_gst}}</td>
            <td style="border: 1px solid #000; text-align: end; font-weight: bold;width: 11%;">{{item1.total_gst}}</td>
            <td style="border: 1px solid #000; text-align: end; font-weight: bold;width: 10%;background-color: #F7BEA2;">{{item1.total_amt}}</td>
            <td style="border: 1px solid #000; text-align: end; font-weight: bold;width: 11%;">{{item1.total_rcv}}</td>
            <td style="border: 1px solid #000; text-align: end; font-weight: bold;width: 10%;">{{item1.total_pending}}</td>
          </tr>
        </ng-container>
      </tbody>
      <tfoot>
        <tr>
          <td style="border: 1px solid #000; font-weight: bold; text-align: center;">{{inDetailsbriflydata.length}}</td>
          <td style="border: 1px solid #000; text-align: center; font-weight: bold;">एकूण</td>
          <td style="border: 1px solid #000; text-align: end; font-weight: bold;">{{advtamtb}}</td>
          <td style="border: 1px solid #000; text-align: end; font-weight: bold;">{{totaladvtamt}}</td>
          <td style="border: 1px solid #000; text-align: end; font-weight: bold;">{{totalbeforegst_amt}}</td>
          <td style="border: 1px solid #000; text-align: end; font-weight: bold;">{{totalgst}}</td>
          <td style="border: 1px solid #000; text-align: end; font-weight: bold;background-color: #F7BEA2;">{{netadvtamt}}</td>
          <td style="border: 1px solid #000; text-align: end; font-weight: bold;">{{jamatotalb}}</td>
          <td style="border: 1px solid #000; text-align: end; font-weight: bold;">{{netadvtamt - jamatotal}}</td>
        </tr>
      </tfoot>
    </table>
  </div>
</div>

<div class="noPrint" style="margin-left: 80%; margin-bottom: 2%">
  <button type="button" mat-raised-button matTooltip="Download Execelsheet" class="btn btn-danger"
    (click)="exportexcel('Registration Report')" style="margin-top: 2%;">
    Export
  </button>
  <button style="margin-top: 2%;" mat-raised-button color="primary" [useExistingCss]="true"
    (click)="printPageA4Portrait()">
    Print
  </button>
  <button mat-dialog-close class="btn">Close</button>
</div>